import React, { useEffect, useState } from "react";
import "./profile.css";
import UseEditProfile from "../../hooks/useEditProfile";
import UseFetchProfile from "../../hooks/useFetchProfile";

function PersonalInfo() {
  const [profile, setProfile] = useState({
    linkedin: "",
    personal_email: "",
    asc_ss_link: "",
    projects: "",
    internships: "",
    pors: "",
    resume_link: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProfile((prevProfile) => ({ ...prevProfile, [name]: value }));
  };

  const { editProfile, loading, error, success } = UseEditProfile();
  const { fetchProfile, fetchedProfile } = UseFetchProfile();

  const handleSubmit = (event) => {
    const accessToken = localStorage.getItem("accessToken");
    profile.accessToken = accessToken;

    editProfile(profile);
  };

  const [check, setCheck] = useState(false);
  const [error1, setError1] = useState(null);

  const validateEmail = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  };

  useEffect(() => {
    if (profile.personal_email) {
      setError1(
        validateEmail(profile.personal_email)
          ? null
          : "Please enter a valid email address"
      );
      if (validateEmail(profile.personal_email)) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    }
  }, [profile.personal_email]);

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (fetchedProfile) {
      const newProfile = {
        linkedin: fetchedProfile?.linkedin,
        personal_email: fetchedProfile?.personal_email,
        sop: fetchedProfile?.sop,
        resume_link: fetchedProfile?.resume_link,
        asc_ss_link: fetchedProfile?.asc_ss_link,
        projects: fetchedProfile?.projects,
        internships: fetchedProfile?.internships,
        pors: fetchedProfile?.pors,
      };
      setProfile(newProfile);
      console.log(fetchedProfile);
    }
  }, [fetchedProfile]);

  return (
    <div className="profile-page">
      <div className="profile-header">
        <h1 className="profile-title">Personal Information</h1>
        <p className="profile-subtitle">
          Complete your profile to register for projects
        </p>
      </div>

      <div className="profile-form-container">
        <div className="form-section">
          <div className="form-row">
            <label htmlFor="Field9" className="form-label">
              LinkedIn Profile Link<span className="required">*</span>
            </label>
            <input
              id="Field9"
              name="linkedin"
              type="url"
              className="form-input"
              value={profile.linkedin || ""}
              onChange={handleInputChange}
              placeholder="https://linkedin.com/in/your-profile"
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="Field10" className="form-label">
              Personal Email<span className="required">*</span>
            </label>
            <input
              id="Field10"
              name="personal_email"
              type="email"
              className="form-input"
              value={profile.personal_email || ""}
              onChange={handleInputChange}
              placeholder="your.email@example.com"
              required
            />
          </div>
        </div>

        <div className="full-width-section">
          <label htmlFor="Field6" className="full-width-label">
            Projects Done (Mention in brief)<span className="required">*</span>
          </label>
          <textarea
            id="Field6"
            name="projects"
            className="form-textarea"
            spellCheck="true"
            value={profile.projects || ""}
            onChange={handleInputChange}
            placeholder="Describe your projects in brief..."
            required
          />
        </div>

        <div className="full-width-section">
          <label htmlFor="Field7" className="full-width-label">
            Internship Experience (Mention in brief)
            <span className="required">*</span>
          </label>
          <textarea
            id="Field7"
            name="internships"
            className="form-textarea"
            spellCheck="true"
            value={profile.internships || ""}
            onChange={handleInputChange}
            placeholder="Describe your internship experience..."
            required
          />
        </div>

        <div className="full-width-section">
          <label htmlFor="Field8" className="full-width-label">
            Positions of Responsibility (Mention in brief)
            <span className="required">*</span>
          </label>
          <textarea
            id="Field8"
            name="pors"
            className="form-textarea"
            spellCheck="true"
            value={profile.pors || ""}
            onChange={handleInputChange}
            placeholder="Describe your positions of responsibility..."
            required
          />
        </div>

        <div className="form-section">
          <div className="form-row">
            <label htmlFor="Field11" className="form-label">
              ASC Screenshot Link<span className="required">*</span>
            </label>
            <input
              id="Field11"
              name="asc_ss_link"
              type="url"
              className="form-input link-input"
              value={profile.asc_ss_link || ""}
              onChange={handleInputChange}
              placeholder="https://drive.google.com/..."
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="Field12" className="form-label">
              Resume Drive Link<span className="required">*</span>
            </label>
            <input
              id="Field12"
              name="resume_link"
              type="url"
              className="form-input link-input"
              value={profile.resume_link || ""}
              onChange={handleInputChange}
              placeholder="https://drive.google.com/..."
              required
            />
          </div>
        </div>

        {error1 && <div className="error-message">{error1}</div>}

        <div className="button-container">
          <button
            disabled={!check}
            onClick={handleSubmit}
            className={`submit-button ${loading ? "loading" : ""}`}
          >
            {loading ? "Saving..." : "Save Profile"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PersonalInfo;
